// extracted by mini-css-extract-plugin
export default {"container":"QEMP2c"};